import BigNumber from 'bignumber.js';
import { Address, PublicClient } from 'viem';

import { getDelegateStakingPoolContract } from 'modules/api/contracts/getDelegateStakingPoolContract';
import { convertFromWei } from 'modules/api/utils';
import { IPool, PoolStatus } from 'modules/pool/types';

export async function getPool(
  client: PublicClient,
  poolAddress: Address,
): Promise<IPool | null> {
  const poolContract = getDelegateStakingPoolContract(client, poolAddress);

  const [isActive, totalStakeWei, feeWei, stakersWei] = await Promise.all([
    poolContract.read.active(),
    poolContract.read.totalStake(),
    poolContract.read.fee(),
    poolContract.read.stakers(),
  ]);

  const totalStake = convertFromWei(totalStakeWei);

  return {
    address: poolAddress,
    status: isActive ? PoolStatus.Active : PoolStatus.Unqualified,
    commission: convertFromWei(feeWei, 2),
    tvl: totalStake,
    totalDelegators: new BigNumber(Number(stakersWei)),
  };
}
